export default "__VITE_ASSET__28e360a8__"